import {LocalizationStore} from 'common/i18n/store';

import {ExampleEventKey, IndustryKey, TranslatableIndustrySpec} from './types';

export const IMMERSIVE_ONBOARDING_URL_PARAM = `immersive-onboarding`;

export const SPRIG_QUALIFIER = `OnboardingFirstImpressionSprig`;

export const SPRIG_QUALIFIER_V2 = `OnboardingPostSurveySprig`;

export const EVENT_INPUT_MAX = 6;

export const LEARN_MIXPANEL_YT_URL = `https://www.youtube.com/embed/Wpl0o0ipeB8?si=8P8Mw0SfyqVlkW6Q&autoplay=1`;

export const DEFAULT_INDUSTRY_KEY = IndustryKey.B2B;
const ExampleEvents: Record<ExampleEventKey, TranslatableIndustrySpec[`default_events`][number]> = {
  [ExampleEventKey.SignUp]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.SignUp}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.country`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.united-states`),
          ({t}) => t(`onboarding.example.property-value.brazil`),
          ({t}) => t(`onboarding.example.property-value.india`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.os`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.android`),
          ({t}) => t(`onboarding.example.property-value.ios`),
          ({t}) => t(`onboarding.example.property-value.pc`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.source`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.social`),
          ({t}) => t(`onboarding.example.property-value.organic`),
          ({t}) => t(`onboarding.example.property-value.email`),
        ],
      },
    ],
  },
  [ExampleEventKey.PageView]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.PageView}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.page-name`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.home`),
          ({t}) => t(`onboarding.example.property-value.about`),
          ({t}) => t(`onboarding.example.property-value.pricing`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.referrer-url-path`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value./home`),
          ({t}) => t(`onboarding.example.property-value./products`),
          ({t}) => t(`onboarding.example.property-value./contact`),
        ],
      },
    ],
  },
  [ExampleEventKey.RequestDemo]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.RequestDemo}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.contact-method`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.email`),
          ({t}) => t(`onboarding.example.property-value.form`),
          ({t}) => t(`onboarding.example.property-value.phone`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.area-of-interest`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.producta`),
          ({t}) => t(`onboarding.example.property-value.productb`),
          ({t}) => t(`onboarding.example.property-value.productc`),
        ],
      },
    ],
  },
  [ExampleEventKey.CreateItem]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.CreateItem}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.item-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.photo`),
          ({t}) => t(`onboarding.example.property-value.video`),
          ({t}) => t(`onboarding.example.property-value.text`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.creation-method`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.app`),
          ({t}) => t(`onboarding.example.property-value.web`),
          ({t}) => t(`onboarding.example.property-value.third-party`),
        ],
      },
    ],
  },
  [ExampleEventKey.Engage]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.Engage}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.engagement-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.like`),
          ({t}) => t(`onboarding.example.property-value.comment`),
          ({t}) => t(`onboarding.example.property-value.share`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.content-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.photo`),
          ({t}) => t(`onboarding.example.property-value.video`),
          ({t}) => t(`onboarding.example.property-value.text`),
        ],
      },
    ],
  },
  [ExampleEventKey.Share]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.Share}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.share-method`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.in-product`),
          ({t}) => t(`onboarding.example.property-value.text`),
          ({t}) => t(`onboarding.example.property-value.copy`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.original-content-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.image`),
          ({t}) => t(`onboarding.example.property-value.video`),
          ({t}) => t(`onboarding.example.property-value.article`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.privacy-setting`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.public`),
          ({t}) => t(`onboarding.example.property-value.private`),
          ({t}) => t(`onboarding.example.property-value.friends-only`),
        ],
      },
    ],
  },
  [ExampleEventKey.ContentView]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.ContentView}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.content-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.movie`),
          ({t}) => t(`onboarding.example.property-value.show`),
          ({t}) => t(`onboarding.example.property-value.clip`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.genre`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.comedy`),
          ({t}) => t(`onboarding.example.property-value.action`),
          ({t}) => t(`onboarding.example.property-value.documentary`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.view-duration`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.full`),
          ({t}) => t(`onboarding.example.property-value.partial`),
          ({t}) => t(`onboarding.example.property-value.brief`),
        ],
      },
    ],
  },
  [ExampleEventKey.PurchaseMedia]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.PurchaseMedia}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.purchase-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.subscription`),
          ({t}) => t(`onboarding.example.property-value.one-time`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.payment-portal`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.in-app`),
          ({t}) => t(`onboarding.example.property-value.web`),
        ],
      },
    ],
  },
  [ExampleEventKey.StartLevel]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.StartLevel}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.level-number`),
        breakdowns: [`1`, `2`, `3`],
      },
      {
        name: ({t}) => t(`onboarding.example.property.game-mode`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.single-player`),
          ({t}) => t(`onboarding.example.property-value.multiplayer`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.hearts-remaining`),
        breakdowns: [`1`, `2`, `3`],
      },
    ],
  },
  [ExampleEventKey.FinishLevel]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.FinishLevel}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.level-number`),
        breakdowns: [`1`, `2`, `3`],
      },
      {
        name: ({t}) => t(`onboarding.example.property.game-mode`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.single-player`),
          ({t}) => t(`onboarding.example.property-value.multiplayer`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.hearts-remaining`),
        breakdowns: [`1`, `2`, `3`],
      },
    ],
  },
  [ExampleEventKey.StartCourse]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.StartCourse}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.course-id`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.course101`),
          ({t}) => t(`onboarding.example.property-value.course205`),
          ({t}) => t(`onboarding.example.property-value.course310`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.course-name`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.intro`),
          ({t}) => t(`onboarding.example.property-value.learning-101`),
          ({t}) => t(`onboarding.example.property-value.advanced-topics`),
        ],
      },
    ],
  },
  [ExampleEventKey.FinishModule]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.FinishModule}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.module-number`),
        breakdowns: [`1`, `2`, `3`],
      },
      {
        name: ({t}) => t(`onboarding.example.property.completion-time`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.30-min`),
          ({t}) => t(`onboarding.example.property-value.60-min`),
          ({t}) => t(`onboarding.example.property-value.120-min`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.final-score`),
        breakdowns: [`80%`, `90%`, `100%`],
      },
    ],
  },
  [ExampleEventKey.FinishCourse]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.FinishCourse}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.course-id`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.course101`),
          ({t}) => t(`onboarding.example.property-value.course205`),
          ({t}) => t(`onboarding.example.property-value.course310`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.course-name`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.intro`),
          ({t}) => t(`onboarding.example.property-value.learning-101`),
          ({t}) => t(`onboarding.example.property-value.advanced-topics`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.total-duration`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.2-days`),
          ({t}) => t(`onboarding.example.property-value.1-week`),
          ({t}) => t(`onboarding.example.property-value.3-weeks`),
        ],
      },
    ],
  },
  [ExampleEventKey.CompleteSearch]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.CompleteSearch}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.search-query`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.symptoms`),
          ({t}) => t(`onboarding.example.property-value.pharmacy`),
          ({t}) => t(`onboarding.example.property-value.diet`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.search-click`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.true`),
          ({t}) => t(`onboarding.example.property-value.false`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.result-shown`),
        breakdowns: [`10`, `20`, `30`],
      },
    ],
  },
  [ExampleEventKey.NewAppointment]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.NewAppointment}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.appointment-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.new-patient`),
          ({t}) => t(`onboarding.example.property-value.general`),
          ({t}) => t(`onboarding.example.property-value.emergency`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.day-of-week`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.monday`),
          ({t}) => t(`onboarding.example.property-value.tuesday`),
          ({t}) => t(`onboarding.example.property-value.wednesday`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.location`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.virtual`),
          ({t}) => t(`onboarding.example.property-value.in-office`),
        ],
      },
    ],
  },
  [ExampleEventKey.ViewItem]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.ViewItem}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.item-id`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.item123`),
          ({t}) => t(`onboarding.example.property-value.item456`),
          ({t}) => t(`onboarding.example.property-value.item678`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.category`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.clothing`),
          ({t}) => t(`onboarding.example.property-value.electronics`),
          ({t}) => t(`onboarding.example.property-value.home-appliances`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.price`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.$0-$50`),
          ({t}) => t(`onboarding.example.property-value.$51-$100`),
          ({t}) => t(`onboarding.example.property-value.over-$100`),
        ],
      },
    ],
  },
  [ExampleEventKey.AddtoCart]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.AddtoCart}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.cart`),
        breakdowns: [`[item1, item2]`, `[item3, item4]`, ({t}) => t(`onboarding.example.property-value.[item3]`)],
      },
      {
        name: ({t}) => t(`onboarding.example.property.category`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.clothing`),
          ({t}) => t(`onboarding.example.property-value.electronics`),
          ({t}) => t(`onboarding.example.property-value.home-appliances`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.price`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.$0-$50`),
          ({t}) => t(`onboarding.example.property-value.$51-$100`),
          ({t}) => t(`onboarding.example.property-value.over-$100`),
        ],
      },
    ],
  },
  [ExampleEventKey.ViewCart]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.ViewCart}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.cart`),
        breakdowns: [`[item1, item2]`, `[item3, item4]`, ({t}) => t(`onboarding.example.property-value.[item3]`)],
      },
      {
        name: ({t}) => t(`onboarding.example.property.category`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.clothing`),
          ({t}) => t(`onboarding.example.property-value.electronics`),
          ({t}) => t(`onboarding.example.property-value.home-appliances`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.total-amount`),
        breakdowns: [`$19.99`, `$49.99`, `$120.60`],
      },
    ],
  },
  [ExampleEventKey.PurchaseEcommerce]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.ViewCart}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.cart`),
        breakdowns: [`[item1, item2]`, `[item3, item4]`, ({t}) => t(`onboarding.example.property-value.[item3]`)],
      },
      {
        name: ({t}) => t(`onboarding.example.property.category`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.clothing`),
          ({t}) => t(`onboarding.example.property-value.electronics`),
          ({t}) => t(`onboarding.example.property-value.home-appliances`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.total-amount`),
        breakdowns: [`$19.99`, `$49.99`, `$120.60`],
      },
    ],
  },
  [ExampleEventKey.SelectBank]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.SelectBank}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.bank-name`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.bank-of-us`),
          ({t}) => t(`onboarding.example.property-value.crescent-bank`),
          ({t}) => t(`onboarding.example.property-value.oakmont`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.account-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.checking`),
          ({t}) => t(`onboarding.example.property-value.savings`),
          ({t}) => t(`onboarding.example.property-value.investment`),
        ],
      },
    ],
  },
  [ExampleEventKey.FundedAccount]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.FundedAccount}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.funding-source`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.bank-transfer`),
          ({t}) => t(`onboarding.example.property-value.credit-card`),
          ({t}) => t(`onboarding.example.property-value.digital-wallet`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.funding-amount`),
        breakdowns: [`$100`, `$1000`, `$5000`],
      },
      {
        name: ({t}) => t(`onboarding.example.property.account-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.checking`),
          ({t}) => t(`onboarding.example.property-value.savings`),
          ({t}) => t(`onboarding.example.property-value.investment`),
        ],
      },
    ],
  },
  [ExampleEventKey.Transaction]: {
    name: ({t}) => t(`onboarding.example.event.${ExampleEventKey.Transaction}`),
    properties: [
      {
        name: ({t}) => t(`onboarding.example.property.transaction-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.deposit`),
          ({t}) => t(`onboarding.example.property-value.withdrawal`),
          ({t}) => t(`onboarding.example.property-value.transfer`),
        ],
      },
      {
        name: ({t}) => t(`onboarding.example.property.amount`),
        breakdowns: [`$50`, `$200`, `$1000`],
      },
      {
        name: ({t}) => t(`onboarding.example.property.recipient-type`),
        breakdowns: [
          ({t}) => t(`onboarding.example.property-value.personal-bank`),
          ({t}) => t(`onboarding.example.property-value.business`),
          ({t}) => t(`onboarding.example.property-value.external`),
        ],
      },
    ],
  },
};
/* eslint-disable @typescript-eslint/naming-convention */
export const IndustrySpecs: Record<IndustryKey, TranslatableIndustrySpec> = {
  [IndustryKey.B2B]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.b2b`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.PageView],
      ExampleEvents[ExampleEventKey.RequestDemo],
    ],
  },
  [IndustryKey.Consumer]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.consumer`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.PageView],
      ExampleEvents[ExampleEventKey.CreateItem],
    ],
  },
  [IndustryKey.Social]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.social`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.PageView],
      ExampleEvents[ExampleEventKey.Engage],
      ExampleEvents[ExampleEventKey.Share],
    ],
  },
  [IndustryKey.Media]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.media`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.ContentView],
      ExampleEvents[ExampleEventKey.Share],
      ExampleEvents[ExampleEventKey.PurchaseMedia],
    ],
  },
  [IndustryKey.Gaming]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.gaming`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.StartLevel],
      ExampleEvents[ExampleEventKey.FinishLevel],
    ],
  },
  [IndustryKey.Education]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.education`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.StartCourse],
      ExampleEvents[ExampleEventKey.FinishModule],
      ExampleEvents[ExampleEventKey.FinishCourse],
    ],
  },
  [IndustryKey.Healthcare]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.healthcare`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.CompleteSearch],
      ExampleEvents[ExampleEventKey.NewAppointment],
    ],
  },
  [IndustryKey.Ecommerce]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.ecommerce`),
    default_events: [
      ExampleEvents[ExampleEventKey.ViewItem],
      ExampleEvents[ExampleEventKey.AddtoCart],
      ExampleEvents[ExampleEventKey.ViewCart],
      ExampleEvents[ExampleEventKey.PurchaseEcommerce],
    ],
  },
  [IndustryKey.Agency]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.agency`),
    default_events: [ExampleEvents[ExampleEventKey.SignUp], ExampleEvents[ExampleEventKey.PageView]],
  },
  [IndustryKey.Finance]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.finance`),
    default_events: [
      ExampleEvents[ExampleEventKey.SignUp],
      ExampleEvents[ExampleEventKey.SelectBank],
      ExampleEvents[ExampleEventKey.FundedAccount],
      ExampleEvents[ExampleEventKey.Transaction],
    ],
  },
  [IndustryKey.Marketplace]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.marketplace`),
    default_events: [ExampleEvents[ExampleEventKey.SignUp], ExampleEvents[ExampleEventKey.PageView]],
  },
  [IndustryKey.Other]: {
    display_name: ({t}: LocalizationStore) => t(`onboarding.example.industry.other`),
    default_events: [ExampleEvents[ExampleEventKey.SignUp], ExampleEvents[ExampleEventKey.PageView]],
  },
};
/* eslint-enable @typescript-eslint/naming-convention */
